/*
Little magic. This module contains store, but got store later.
*/
export default {
  store: null,
}
